import { useEffect, useRef, useState } from "react";
import { endpoints } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { SubscribeDialog } from "@/components/SubscribeDialog";
import { pickCurrency } from "@/lib/currency";

const safeCurrency = (list, user) => { try { return pickCurrency(list, user) || "RWF"; } catch { return "RWF"; } };

// Global subscribe/payment flow. Any component can dispatch:
//   window.dispatchEvent(new CustomEvent("open-subscribe", { detail: { planId } }))
// and this opens the payment dialog with a plan preselected (premium monthly by default).
export const SubscribeGate = () => {
  const { isAuthed, isSubscribed, user } = useAuth();
  const [open, setOpen] = useState(false);
  const [plan, setPlan] = useState(null);
  const [stay, setStay] = useState(false);
  const plansRef = useRef([]);
  const [currencies, setCurrencies] = useState([]);
  useEffect(() => { endpoints.billingCurrencies().then((r) => setCurrencies(r.data?.currencies || [])).catch(() => {}); }, []);
  const pendingRef = useRef(null);

  const pick = (list, id) =>
    list.find((p) => p.id === id) ||
    list.find((p) => p.tier === "premium" && p.period === "monthly") ||
    list[0];

  const doOpen = async (planId) => {
    let list = plansRef.current;
    if (!list.length) {
      try { const { data } = await endpoints.plans(); list = data; plansRef.current = data; }
      catch { return; }
    }
    setPlan(pick(list, planId));
    setOpen(true);
  };

  useEffect(() => {
    const handler = (e) => {
      if (isSubscribed) return;
      const planId = e?.detail?.planId;
      setStay(e?.detail?.reason === "preview");
      if (!isAuthed) { pendingRef.current = planId || "__any__"; window.dispatchEvent(new Event("open-auth")); return; }
      doOpen(planId);
    };
    window.addEventListener("open-subscribe", handler);
    return () => window.removeEventListener("open-subscribe", handler);
  });

  // After a pending sign-in completes, continue straight to payment.
  useEffect(() => {
    if (isSubscribed) { setOpen(false); return; }
    if (isAuthed && pendingRef.current) {
      const pid = pendingRef.current === "__any__" ? undefined : pendingRef.current;
      pendingRef.current = null;
      doOpen(pid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthed, isSubscribed]);

  return <SubscribeDialog plan={plan} currencies={currencies} currency={safeCurrency(currencies, user)} open={open} stay={stay} onClose={() => setOpen(false)} />;
};
